import { Component } from "@theme/component";

/**
 * Display a tooltip on click
 * @property {string[]} requiredRefs - Required refs: 'tooltip'
 */
class TooltipComponent extends Component {
  requiredRefs = ['tooltip']

  /**
   * Toggle tooltip display
   * @param {Event} event
   */
  toggle(event) {
    const tooltip = this.refs.tooltip;
    if (!(tooltip instanceof Element)) return;
    if (tooltip.classList.contains('hidden')) {
      this.show(event);
    } else {
      this.hide(event);
    }
  }

  /**
   * Show tooltip display
   * @param {Event} event
   */
  show(event) {
    const tooltip = this.refs.tooltip;
    if (!(tooltip instanceof Element)) return;
    event?.stopPropagation();
    window.addEventListener('click', this.#closeEvent);
    tooltip.classList.remove('hidden');
  }

  /**
   * Hide tooltip display
   * @param {Event} event
   */
  hide(event) {
    const tooltip = this.refs.tooltip;
    if (!(tooltip instanceof Element)) return;
    event?.stopPropagation();
    window.removeEventListener('click', this.#closeEvent);
    tooltip.classList.add('hidden');
  }

  /**
   * Handle a close event
   * @param {Event} event
   */
  #closeEvent = (event) => {
    if (!(event.target instanceof Element)) return;

    const tooltip = this.refs.tooltip;
    if (!(tooltip instanceof Element)) return;

    if (!tooltip.contains(event.target)) {
      this.hide(event);
    }
  }

}

if (!customElements.get('tooltip-component')) {
  customElements.define('tooltip-component', TooltipComponent);
}
